import { TabsTrigger } from "@/Components/ui/tabs"
import { cn } from "@/lib/utils"
export default function ListingTabTrigger({
    className,
    position = "middle",
    ...props
}) {
    const positionClasses = {
        first: "rounded-l-lg border-y border-l border-r",
        middle: "border-y border-r",
        last: "rounded-r-lg border-y border-r",
    }[position]
    return (
        <TabsTrigger
            className={cn(
                "flex md:min-h-[35px] w-full rounded-lg font-bold flex-col items-center justify-center px-2 md:px-6 py-2 text-xs md:text-sm",
                "border-none bg-white text-[#5F5E5E]",
                "data-[state=active]:bg-[#8B0D2F]  data-[state=active]:text-white",

                className
            )}
            {...props}
        />
    )
}
